module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABK0lEQVRYheVYWw7CMAxzEPe/cvhZUFSVbqtdSoQlJMhQZjePJTMAcHdUxWM3ARblBTzVDs3sYz66u8nvdzjmHR3ER56CvVKIJIXMzB1j8jiuO8ZRugtaQJC/A6UISsAM+YBKRPkuNF3E3dPPFrNz+0GAKWptBHqkB+QV0KfQxZNXYU0NtGQXkQdWCWirY+GwqBdwpZCF0ArokV8sgpqFmAdZ3Jydi8o/yCgB7j7dXxSnDwgiMCNCRR4QpVCIOGMU/1HuA7KF5u2w6ka2C//dhX4B9FuJnPMrcvwM/ErpbvHJYpSL+wjSFNoRAfmLrYyIUHwPe8+W7XdACWjTpiWQieZr+fcn+1XQEWAJsCjfRukupCIyzQHgRolRDXyjiLfOQoqaKV8D5afR8ngB+8q8KSlCkVgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/IESTOP_A.png
// module id = 78
// module chunks = 0